<div class="page-header">
  <div class="page-title" data-clarity-unmask="true">Zgłoszenia / Opinie</div>
  <div class="page-subtitle">zgłoszenia błędów i oceny z aplikacji, z urządzeniem, z którego zostały wysłane</div>
</div>

<div class="support-reports">
  <div class="flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
    <p-selectButton [options]="filterOptions" [(ngModel)]="showAll" optionLabel="label" optionValue="value"
      [allowEmpty]="false" (onChange)="applyFilter()"
      pTooltip="Bez odpowiedzi: zgłoszenia i oceny z opinią od zalogowanych, na które nikt nie odpowiedział ani ich nie oznaczył jako odpowiedziane"
      tooltipPosition="bottom" />
    <p-button label="Odśwież" icon="pi pi-refresh" size="small" [outlined]="true" [loading]="loading" (onClick)="refresh()" data-clarity-unmask="true" />
  </div>

  @if (errorMessage) {
    <div class="banner error">
      <i class="pi pi-exclamation-triangle"></i>
      <span>{{ errorMessage }}</span>
    </div>
  }

  @if (successMessage) {
    <div class="banner success">
      <i class="pi pi-check-circle"></i>
      <span>{{ successMessage }}</span>
      @if (undoHandled; as undo) {
        <p-button label="Cofnij" size="small" [link]="true" (onClick)="setHandled(undo.item, undo.kind, false)" data-clarity-unmask="true" />
      }
    </div>
  }

  <p-tabView>
    <p-tabPanel [header]="tabHeader('Zgłoszenia błędów', visibleIssueReports, issueReports)">
      <p-table [value]="visibleIssueReports" styleClass="p-datatable-sm" [scrollable]="true" [paginator]="visibleIssueReports.length > 25"
        [rows]="25" [loading]="loading">
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="created">Data <p-sortIcon field="created" /></th>
            <th>Użytkownik</th>
            <th>Urządzenie</th>
            <th>Opis</th>
            <th>Zdjęcie</th>
            <th>Odpowiedź</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-report>
          <tr>
            <td class="nowrap">{{ report.created | date: 'yyyy-MM-dd HH:mm' }}</td>
            <td data-label="Użytkownik"><app-user-account-link [email]="report.createdByEmail" [userGuid]="report.createdByGuid" fallback="niezalogowany" /></td>
            <td data-label="Urządzenie"><app-client-device [device]="report.clientDevice" /></td>
            <td class="message" data-label="Opis">{{ report.description }}</td>
            <td data-label="Zdjęcie">
              @if (report.attachmentUrl) {
                <a [href]="resolveUrl(report.attachmentUrl)" target="_blank" rel="noopener">
                  <img class="attachment" [src]="resolveUrl(report.attachmentUrl)" alt="Załącznik" />
                </a>
              }
            </td>
            <td class="actions" data-label="Odpowiedź">
              <ng-container *ngTemplateOutlet="replyCell; context: { $implicit: report, kind: 'issue' }" />
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr><td colspan="6" class="empty">{{ showAll ? 'Brak zgłoszeń.' : 'Brak zgłoszeń bez odpowiedzi.' }}</td></tr>
        </ng-template>
      </p-table>
    </p-tabPanel>

    <p-tabPanel [header]="tabHeader('Oceny aplikacji', visibleAppRatings, appRatings)">
      <p-table [value]="visibleAppRatings" styleClass="p-datatable-sm" [scrollable]="true" [paginator]="visibleAppRatings.length > 25"
        [rows]="25" [loading]="loading">
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="created">Data <p-sortIcon field="created" /></th>
            <th>Użytkownik</th>
            <th>Urządzenie</th>
            <th pSortableColumn="rating">Ocena <p-sortIcon field="rating" /></th>
            <th>Opinia</th>
            <th>Zdjęcie</th>
            <th>Odpowiedź</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rating>
          <tr>
            <td class="nowrap">{{ rating.created | date: 'yyyy-MM-dd HH:mm' }}</td>
            <td data-label="Użytkownik"><app-user-account-link [email]="rating.createdByEmail" [userGuid]="rating.createdByGuid" fallback="niezalogowany" /></td>
            <td data-label="Urządzenie"><app-client-device [device]="rating.clientDevice" /></td>
            <td class="nowrap stars" data-label="Ocena">{{ stars(rating.rating) }}</td>
            <td class="message" data-label="Opinia">{{ rating.feedback || '—' }}</td>
            <td data-label="Zdjęcie">
              @if (rating.attachmentUrl) {
                <a [href]="resolveUrl(rating.attachmentUrl)" target="_blank" rel="noopener">
                  <img class="attachment" [src]="resolveUrl(rating.attachmentUrl)" alt="Załącznik" />
                </a>
              }
            </td>
            <td class="actions" data-label="Odpowiedź">
              <ng-container *ngTemplateOutlet="replyCell; context: { $implicit: rating, kind: 'rating' }" />
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr><td colspan="7" class="empty">{{ showAll ? 'Brak ocen.' : 'Brak ocen bez odpowiedzi.' }}</td></tr>
        </ng-template>
      </p-table>
    </p-tabPanel>
  </p-tabView>
</div>

<ng-template #replyCell let-item let-kind="kind">
  <span class="actions-row">
    @if (item.createdByEmail) {
      <p-button
        icon="pi pi-reply"
        size="small"
        [text]="true"
        [rounded]="true"
        [pTooltip]="kind === 'issue' ? 'Odpowiedz na zgłoszenie' : 'Odpowiedz na opinię'"
        tooltipPosition="left"
        (onClick)="kind === 'issue' ? openIssueReply(item) : openRatingReply(item)"
        data-clarity-unmask="true"
      />
    } @else {
      <span class="muted" pTooltip="Wysłane bez logowania — nie ma adresu do odpowiedzi" tooltipPosition="left">—</span>
    }
    @if (!item.replies?.length) {
      @if (item.handledAt) {
        <p-button
          icon="pi pi-check-square"
          size="small"
          severity="info"
          [text]="true"
          [rounded]="true"
          [loading]="isHandledPending(item, kind)"
          [pTooltip]="
            'Oznaczone jako odpowiedziane bez wiadomości ' +
            (item.handledAt | date: 'yyyy-MM-dd HH:mm') +
            (item.handledByEmail ? ' · ' + item.handledByEmail : '') +
            '. Kliknij, aby cofnąć.'
          "
          tooltipPosition="left"
          (onClick)="setHandled(item, kind, false)"
          data-clarity-unmask="true"
        />
      } @else {
        <p-button
          icon="pi pi-check"
          size="small"
          severity="secondary"
          [text]="true"
          [rounded]="true"
          [loading]="isHandledPending(item, kind)"
          pTooltip="Oznacz jako odpowiedziane, bez wysyłania wiadomości"
          tooltipPosition="left"
          (onClick)="setHandled(item, kind, true)"
          data-clarity-unmask="true"
        />
      }
    }
    @if (lastReply(item); as reply) {
      <i
        class="pi pi-check-circle answered"
        [pTooltip]="
          'Odpowiedziano ' +
          (reply.sentAt | date: 'yyyy-MM-dd HH:mm') +
          (item.replies.length > 1 ? ' (odpowiedzi: ' + item.replies.length + ')' : '')
        "
        tooltipPosition="left"
      ></i>
    }
  </span>
</ng-template>

<app-reply-dialog
  [header]="replyHeader"
  [(visible)]="replyVisible"
  [email]="replyTarget?.email"
  [userGuid]="replyTarget?.userGuid"
  [thread]="replyTarget?.thread ?? []"
  [(subject)]="replySubject"
  [(body)]="replyBody"
  hint="Wiadomość wyjdzie od razu na adres konta, z którego wysłano zgłoszenie lub ocenę."
  [sending]="replying"
  [error]="replyError"
  (send)="sendReply()"
/>
